// ScrollToTopButton.jsx

import React, { useEffect, useState } from "react";
import { FaArrowUp } from "react-icons/fa";

function ScrollToTopButton() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.scrollY > 300) {
        setVisible(true);
      } else {
        setVisible(false);
      }
    };

    window.addEventListener("scroll", toggleVisibility);

    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  if (!visible) return null;

  return (
    <button
      onClick={scrollToTop}
      style={{
        position: "fixed",
        bottom: "35px",
        right: "35px",
        width: "52px",
        height: "52px",
        borderRadius: "50%",
        border: "none",
        backgroundColor: "#263f86",
        color: "#fff",
        fontSize: "18px",
        cursor: "pointer",
        boxShadow: "0 6px 14px rgba(0,0,0,0.2)",
        zIndex: 999,
        transition: "all 0.25s ease",
      }}
    >
      <FaArrowUp />
    </button>
  );
}

export default ScrollToTopButton;